import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Col, Row, Card, CardBody, Form, FormGroup, Label } from 'reactstrap';
import { Link } from 'react-router-dom';
import MyAutosuggest from '../../../components/ReusableComponents/AutoSuggest/index';
import withAuth from '../../../components/Services/WithAuth';
import { setSectionTemplateSearchId } from './action';
import './section-template-search.scss';
class SearchSectionTemplate extends Component {
    constructor() {
        super();
        this.state = {
            selectedOption: true,
        }
    }
    searchCallback = (value) => {
        this.props.setSectionTemplateSearchId(value);
        if (value.id) {
            this.setState({ selectedOption: false });
        } else {
            this.setState({ selectedOption: true });
        }
    }
    handleView = () => {
        this.props.history.push(`../sectiontemplate/view/${this.props.selectedSearchOptionId.sectionTemplateSearchData.id}`);
    }
    handleCreateScorecard = () => {
        this.props.history.push('./create');
    }
    render() {
        const inputProps = {
            placeholder: "Start typing section template name...",
            onChange: this.onChange,
            disabled: false,
            className: "form-control",
            value: ""
        }
        return (
            <Col>
                <Row>
                    <Col>
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <h4 className="mb-0">
                                Search Section Templates
                            </h4>
                            <Button color="primary" title="Create Section Template" tag={Link} to="/sectiontemplate/create">Create Section Template</Button>
                        </div>
                        <Card>
                            <CardBody>
                                <Form className="w-70">
                                    <FormGroup>
                                        <Label for="sectionTemplate">Search</Label>
                                        <Row>
                                            <Col xs="20">
                                                <MyAutosuggest
                                                    id="sectionTemplate"
                                                    placeholder="Search Section Template"
                                                    onChange={this.handleFinancialChange}
                                                    financialData={this.props.financialSearch}
                                                    searchCallback={this.searchCallback}
                                                    inputProps={inputProps}
                                                />
                                            </Col>
                                            <Col xs="4" className="pl-0">
                                                <Button className="pl-0" color="link" disabled={this.state.selectedOption} onClick={this.handleView}>View Details</Button>
                                            </Col>
                                        </Row>
                                    </FormGroup>
                                </Form>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                {/* <div className="col section-template-search">
                <div className="w-75 mx-auto text-center">
                    <div className="btn-group pull-right" role="group" aria-label="Scorecard Actions">
                        <button type="button" className="btn btn-light" title="Create Scorecard" onClick={this.handleCreateScorecard}>
                            <span className="fa fa-plus fa-fw" aria-hidden="true"></span>
                        </button>
                    </div>
                    <h3> Section Template </h3>
                    <div className="form-group row mt-4">
                        <div className="col-3">
                            <label htmlFor="title" className="score-bar"><strong>Search</strong></label>
                        </div>
                        <div className="col-18">
                            <MyAutosuggest
                                id="sectionTemplate"
                                placeholder="Search Section Template"
                                onChange={this.handleFinancialChange}
                                financialData={this.props.financialSearch}
                                searchCallback={this.searchCallback}
                                inputProps={inputProps}
                            />
                        </div>
                        <div className="col-3 pl-0">
                            <button type="button" className="btn btn-link pl-0" disabled={this.state.selectedOption} onClick={this.handleView}>
                                <span className="fa fa-info-circle"></span>&nbsp;View Details
                            </button>
                        </div>
                    </div>
                </div>
            </div> */}
            </Col>
        )
    }
}
const mapStateToProps = (state, ownProps) => ({
    selectedSearchOptionId: state.sectionTemplateSearch
});

const mapDispatchToProps = (dispatch, ownProps) => ({
    setSectionTemplateSearchId: (value) => dispatch(setSectionTemplateSearchId(value))
});
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withAuth(SearchSectionTemplate));
